import { ChartArea, FileSliders, Sparkles } from 'lucide-react';
import React from 'react';

import { default as LogoCRM } from 'src/assets/images/logos/miliboo-crm-min.svg?react';
import { default as LogoPIM } from 'src/assets/images/logos/miliboo-pim-min.svg?react';
import { default as LogoSAV } from 'src/assets/images/logos/miliboo-sav-min.svg?react';
import { default as LogoTMS } from 'src/assets/images/logos/miliboo-tms-min.svg?react';

export const sidebarProjectsConfig = [
  {
    name: 'TMS',
    logo: (
      <LogoTMS
        style={{ width: '48px', height: '48px' }}
        className='rounded-md text-white'
      />
    ),
    plan: 'Transport',
    link: 'https://tms.demo.miliboo.io/login',
  },
  {
    name: 'PIM',
    logo: (
      <LogoPIM
        style={{ width: '48px', height: '48px' }}
        className='rounded-md text-white'
      />
    ),
    plan: 'Product',
    link: 'https://pim.nw.demo.miliboo.io/login',
  },
  {
    name: 'CRM',
    logo: (
      <LogoCRM
        style={{ width: '48px', height: '48px' }}
        className='rounded-md text-white'
      />
    ),
    plan: 'Commercial',
    link: 'https://commercial.nw.demo.miliboo.io/login',
  },
  {
    name: 'SAV',
    logo: (
      <LogoSAV
        style={{ width: '48px', height: '48px' }}
        className='rounded-md text-white'
      />
    ),
    plan: 'Aftersales',
    link: 'https://intra.legacy.demo.miliboo.io/sav/recherche_sav_v2.php',
  },
];

export const sidebarMainNavigationConfig = [
  {
    title: 'Forecast',
    url: '/forecast',
    icon: ChartArea,
  },
  {
    title: 'Configuration',
    url: '/configuration',
    icon: FileSliders,
  },
  {
    title: 'Novelties',
    url: '/novelties',
    icon: Sparkles,
  },
];
